import { Box, Typography } from "@mui/material";
import { EventBusy } from "@mui/icons-material";

const EmptyState = ({ userName }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="300px"
      color="text.secondary"
    >
      <EventBusy sx={{ fontSize: 60, mb: 2, opacity: 0.5 }} />
      <Typography variant="h6">No Records Found</Typography>
      <Typography variant="body2">
        {`There is no break data available for ${userName}.`}
      </Typography>
    </Box>
  );
};

export default EmptyState;
